import ChooseRegionsFromTemplate from './ChooseRegionsFromTemplate';

export default ChooseRegionsFromTemplate;
